module.exports = __webpack_public_path__ + "fonts/nunito-variable-latin-ext.d3a4277.woff2";